var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-item-label",attrs:{"for":_vm.id}},[_c('span',[_vm._v("Q.")]),_vm._t("default"),(_vm.required)?_c('em',[_vm._v("*")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }